import React, { Component } from 'react'
import { Modal, Form, Input, Row, Col, Checkbox, Select } from 'antd'

class userEditModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      error: null
    }
  }

  handleOk = (e) => {
    e.preventDefault()

    this.setState({
      error: '',
      loading: true
    })

    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.groupIds = values.groupIds.map(id => Number(id))
        this.props.updateUserById(this.props.user.id, values).then(response => {
          if (!response.data.error) {
            this.props.updateTable({
              keys: [],
              rows: []
            })
            this.handleCancel()
            this.props.getDivisions()

            this.setState({
              loading: false
            })
          } else {
            this.setState({
              error: response.data.error.message,
              loading: false
            })
          }
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }

  handleCancel = (e) => {
    this.props.closeModal()
  }

  divisionFieldValidator = (rule, value, callback) => {
    const { division: { list } } = this.props
    const userDivision = this.props.user.division
    if((value && !userDivision) || (userDivision && (userDivision.id !== Number(value)))) {
      const selectedDivision = list.filter(division => division.id === Number(value))[0]

      if(selectedDivision && (selectedDivision.licenseNumber === selectedDivision.usedLicenseNumber)) {
        callback('Licenses quota is reached')
      }
    }

    if(!value) {
      callback('Please, select a division')
    }

    callback()
  }

  render () {
    const { user } = this.props
    const { division: { list }, form: { getFieldDecorator } } = this.props

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Edit user'
        visible={this.props.status}
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        okText={'Save'}
        okType='indigo'
        okButtonProps={{loading: this.state.loading}}
        destroyOnClose
        width={455}
      >

        { this.state.error && <div className='form__error'>{ this.state.error }</div> }

        <Form onSubmit={this.handleOk} className='form' autoComplete='new-password'>

          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Groups'>Division</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('divisionId', {
                  rules: [{
                    required: true,
                    validator: this.divisionFieldValidator
                  }],
                  initialValue: user.division ? user.division.id.toString() : ''
                })(
                  <Select
                    allowClear
                    name='divisionId'
                    placeholder='Select Division'
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    { list.map(division => <Select.Option key={division.id.toString()}>{ division.name }</Select.Option>) }
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Groups'>Groups</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('groupIds', {
                  rules: [{
                    required: false,
                    message: 'Please select user groups',
                    type: 'array'
                  }],
                  initialValue: user.groups ? user.groups.map(group => group.id.toString()) : []
                })(
                  <Select
                    mode='multiple'
                    name='groupIds'
                    placeholder='Select Groups'
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    { this.props.group.list.map(group => <Select.Option key={group.id.toString()}>{ group.name }</Select.Option>) }
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='First Name'>First Name</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('firstName', {
                  rules: [{
                    required: true,
                    message: 'Please input user First Name',
                    max: 32
                  }],
                  initialValue: user.firstName
                })(
                  <Input name='firstName' placeholder='First Name' maxLength={32} />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Last Name'>Last Name</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('lastName', {
                  rules: [{
                    required: true,
                    message: 'Please input user Last Name',
                    max: 32
                  }],
                  initialValue: user.lastName
                })(
                  <Input name='lastName' placeholder='Last Name' maxLength={32} />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Activate status'>Active</label>
                
              </div>
            </Col>
            <Col span={14}>
              <Form.Item style={{ marginTop: '4px' }} help={(user.division && !user.division.active) ? 'User’s division is inactive' : ''}>
                {getFieldDecorator('activateStatus', {
                  rules: [{
                    required: false
                  }],
                  initialValue: user.activated,
                  valuePropName: 'checked',
                })(
                  <Checkbox name='activateStatus' disabled={user.division && !user.division.active} />
                )}
              </Form.Item>
            </Col>
          </Row>

          {/* <Row>
            <Col span={10}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Groups'>Role</label>
              </div>
            </Col>
            <Col span={14}>
              <Form.Item>
                {getFieldDecorator('role', {
                  rules: [{
                    required: false,
                    message: 'Please select user role'
                  }],
                  initialValue: user.role
                })(
                  <Select
                    name='role'
                    placeholder='Select Role'>
                    <Select.Option value='DIVISION_ADMIN'>Administrator</Select.Option>
                    <Select.Option value='USER'>User</Select.Option>
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row> */}

        </Form>
      </Modal>
    )
  }
}

export default Form.create()(userEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/UserEditModal/UserEditModal.jsx